<div class="modal-content meraki-emission-modal">

  <!-- Background Processing State (Shown when generation is handed off to backend) -->
  <div class="background-processing-container" *ngIf="isProcessing && !hasError">
    <div class="status-content">
      <div class="pulse-ring">
        <mat-icon class="processing-icon">cloud_sync</mat-icon>
      </div>

      <h3 class="status-title">Generation in Progress</h3>

      <div class="message-card">
        <p class="status-msg">
          We are <strong>processing your report at the backend</strong>.
          The system is gathering all the data points required for your vessels.
        </p>
        <p class="status-msg highlighted">
          You can <strong>safely close this popup</strong> and continue your work;
          the results will appear automatically once ready.
        </p>
      </div>

      <button type="button" class="btn-confirm-bg" (click)="closeModal()">
        GOT IT, CLOSE
      </button>
    </div>
  </div>

  <!-- Error State -->
  <div class="background-processing-container error-container" *ngIf="hasError">
    <div class="status-content">
      <div class="pulse-ring">
        <mat-icon class="error-icon">error_outline</mat-icon>
      </div>

      <h3 class="status-title error-title">Generation Failed</h3>

      <div class="message-card error-message-card">
        <p class="status-msg text-danger">
          {{ errorMessage }}
        </p>
      </div>

      <div class="error-actions">
        <!-- <button type="button" class="btn-retry" (click)="retry()">
           TRY AGAIN
        </button> -->
        <button type="button" class="btn-close-error" (click)="closeModal()">
          CLOSE
        </button>
      </div>
    </div>
  </div>

  <!-- Standard Form Content (Hidden during processing or error) -->
  <ng-container *ngIf="!isProcessing && !hasError">
    <!-- Close Button -->
    <button type="button" class="btn-close-modal" mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>

    <!-- Title Section -->
    <div class="modal-header-section">
      <h2 class="main-title">Emission Report</h2>
      <p class="sub-title">Generate comprehensive voyage performance data</p>
    </div>

    <div class="modal-divider"></div>

    <!-- Quick Select Section -->
    <div class="quick-pick-section">
      <span class="section-label">Quick Selection</span>
      <div class="chip-container">
        <button type="button" class="period-chip" (click)="quickSelect('Q1')">Q1</button>
        <button type="button" class="period-chip" (click)="quickSelect('Q2')">Q2</button>
        <button type="button" class="period-chip" (click)="quickSelect('Q3')">Q3</button>
        <button type="button" class="period-chip" (click)="quickSelect('Q4')">Q4</button>
        <button type="button" class="period-chip" (click)="quickSelect('Year')">Year</button>
        <button type="button" class="period-chip ytd-chip" (click)="quickSelect('YTD')">YTD</button>
      </div>
    </div>

    <!-- Form Section -->
    <form [formGroup]="myshipForm" class="emission-form">
      <div class="date-range-row">
        <div class="date-group">
          <label>From Date & Time</label>
          <div class="inputs-stack">
            <app-custom-date-picker [placeholder]="'Select Date'" [controlname]="myshipForm.controls['fromDate']"
              [formSubmitted]="myshipForm.touched">
            </app-custom-date-picker>
            <div class="time-input-container">
              <mat-icon class="time-icon">schedule</mat-icon>
              <input
                type="time"
                class="time-picker-control"
                formControlName="fromTime"
                title="Start Time" />
            </div>
          </div>
        </div>

        <div class="date-group separator">
          <div class="separator-circle">
            <mat-icon>arrow_forward</mat-icon>
          </div>
        </div>

        <div class="date-group">
          <label>To Date & Time</label>
          <div class="inputs-stack">
            <app-custom-date-picker [placeholder]="'Select Date'" [controlname]="myshipForm.controls['toDate']"
              [minDate]="minEndDate" [formSubmitted]="myshipForm.touched">
            </app-custom-date-picker>
            <div class="time-input-container">
              <mat-icon class="time-icon">schedule</mat-icon>
              <input
                type="time"
                class="time-picker-control"
                formControlName="toTime"
                title="End Time" />
            </div>
          </div>
        </div>
      </div>
    </form>

    <!-- Actions -->
    <div class="modal-actions-section">
      <button type="button" class="btn-generate-report" [disabled]="isSubmitting" (click)="submit()">
        <span *ngIf="!isSubmitting">Generate {{ reportType }} Report</span>
        <span *ngIf="isSubmitting" class="loading-state">
          <mat-icon class="spin">sync</mat-icon> Preparing...
        </span>
      </button>
    </div>
  </ng-container>
</div>